import { pushEvent } from './helpers.js';

const setUserObjectDataLayer = (isLoggedIn = false)=>{
    pushEvent({
        event: 'user_data_loaded',
        user: {
            loginStatus: isLoggedIn.toString()
        }
    });
};

export { setUserObjectDataLayer };
//# sourceMappingURL=user.js.map
